import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { finalize, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SuperAdminAuthService } from '../core/services/super-admin-auth.service';
import { Store } from '@ngrx/store';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgClass } from '@angular/common';
import { IconModule } from "../shared/icon/icon.module";
import { AppService } from '../service/app.service';
import { SUPER_ADMIN_PERMISSION_SLUGS } from '../core/constants/super-admin-permission-slugs';
import { PermissionService } from '../core/services/permission.service';
import { HasPermissionPipe } from '../core/pipes/has-permission.pipe';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    standalone: true,
    imports: [
    NgClass,
    RouterLink,
    NgScrollbarModule,
    RouterLinkActive,
    TranslateModule,
    IconModule,
    HasPermissionPipe,
],
})
export class SidebarComponent implements OnInit, OnDestroy {
    private readonly layoutApp = inject(AppService);
    private readonly auth = inject(SuperAdminAuthService);
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly destroy$ = new Subject<void>();
    readonly permissionService = inject(PermissionService);
    readonly store = this.layoutApp.indexState;
    readonly slugs = SUPER_ADMIN_PERMISSION_SLUGS;

    active = false;
    activeDropdown: string[] = [];
    parentDropdown: string = '';
    constructor(
        public translate: TranslateService,
        public storeData: Store<any>,
        public router: Router,
    ) {}

    /** Calls backend to revoke session and clear cookie, then navigates to sign-in. */
    logout(): void {
        this.toggleMobileMenu();
        this.permissionService.clearPermissions();
        this.auth
            .logout()
            .pipe(
                finalize(() =>
                    void this.router.navigate(['/auth/signin'], { replaceUrl: true }),
                ),
            )
            .subscribe({
                error: () => {
                    /* navigate in finalize even if request fails */
                },
            });
    }
    ngOnInit() {
        this.setActiveDropdown();
        this.permissionService.permissionsRevision$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.cdr.detectChanges());
        this.permissionService.ensureLoaded()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.cdr.detectChanges());
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + globalThis.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'toggleSidebar' });
        }
    }

    toggleAccordion(name: string, parent?: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }
}
